import axios from "axios";
import { API_BASE_URL } from "../constants/api";
import { ACCESS_TOKEN } from "../constants/auth";

const authHeader = () => ({
    Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
});

const DailyMonitoringService = {
    /**
     * Публичный список дневной статистики.
     * @param {Object} params
     * @param {"WATER"|"KORDAI"} [params.source]
     * @param {string} [params.from] — YYYY-MM-DD
     * @param {string} [params.to]   — YYYY-MM-DD
     */
    async list({ source, from, to } = {}) {
        const response = await axios.get(`${API_BASE_URL}/api/water/daily`, {
            params: { source, from, to },
        });
        return response.data;
    },

    /** Админский список (то же, что публичный, но с авторизацией — может быть расширен). */
    async adminList({ source, from, to } = {}) {
        const response = await axios.get(`${API_BASE_URL}/api/admin/water/daily`, {
            params: { source, from, to },
            headers: authHeader(),
        });
        return response.data;
    },

    /**
     * Создать или обновить ручной ввод за день.
     * @param {{source:"WATER"|"KORDAI", date:string, manualTotalFlow:number, manualNote?:string}} payload
     */
    async upsertManual(payload) {
        const response = await axios.post(
            `${API_BASE_URL}/api/admin/water/daily`,
            payload,
            { headers: { ...authHeader(), "Content-Type": "application/json" } }
        );
        return response.data;
    },

    async deleteManual(id) {
        const response = await axios.delete(
            `${API_BASE_URL}/api/admin/water/daily/${id}`,
            { headers: authHeader() }
        );
        return response.data;
    },
};

export default DailyMonitoringService;
